import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Modal, Button, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';
import entityComposition from '../../common/classes/entityComposition';
import DateTimePicker from '../../common/controls/dateTimePicker';
import MultiPicker from '../../common/controls/multiPicker';
const DashboardFilterModal = ({
  jobs: propsJobs = [],
  jobSelectDashboardActions,
  jobSelectDashboard,
  onFilter,
  onHide,
  start: propsStart,
  stop: propsStop,
  show
}) => {
  const [start, setStart] = useState(propsStart);
  const [stop, setStop] = useState(propsStop);
  const [jobs, setJobs] = useState(propsJobs);
  const handleCancel = () => onHide();
  const handleChangeJobs = values => setJobs(values);
  const handleChangeStart = value => setStart(value);
  const handleChangeStop = value => setStop(value);
  const handleFilter = () => onFilter({
    jobs,
    start,
    stop
  });
  const updateDisabled = !(start && stop);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: show,
    toggle: handleCancel
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    closebutton: "true",
    "data-testid": "t-dfm-title"
  }, "Dashboard Filters"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    onChange: handleChangeStart,
    label: "Start",
    defaultValue: start
  })), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    onChange: handleChangeStop,
    label: "Stop",
    defaultValue: stop
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(MultiPicker, {
    label: "Jobs",
    labelKey: "jobNumber",
    valueKey: "id",
    entity: jobSelectDashboard,
    entityActions: jobSelectDashboardActions,
    values: jobs,
    returnValueKey: "id",
    placeholder: "All",
    onChange: handleChangeJobs
  })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    disabled: updateDisabled,
    color: "primary",
    onClick: handleFilter,
    className: "tqc-control",
    "data-testid": "t-dfm-updateButton"
  }, "Update"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleCancel,
    className: "tqc-control",
    "data-testid": "t-dfm-cancelButton"
  }, "Cancel")));
};
DashboardFilterModal.propTypes = {
  jobSelectDashboard: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool
  }).isRequired,
  jobSelectDashboardActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({})),
  onFilter: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  start: PropTypes.string.isRequired,
  stop: PropTypes.string.isRequired
};
export { DashboardFilterModal as TestDashboardFilterModal };
export default entityComposition(DashboardFilterModal, ['jobSelectDashboard'], {});